import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./ProductCard.css";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia
      component="img"
      image={product.image}
      />
      {/* <div className="itemImage">
        <CardMedia component="img" image={product.image} />
      </div> */}
      <CardContent className="cardText">
        <Typography  variant="h6" component="span">
          {product.name}
        </Typography>
        <Typography variant="h6" color="text.secondary">
          ${product.cost}
        </Typography>
        <div>
          <Rating name="size-medium" defaultValue={product.rating} readOnly />
        </div>
      </CardContent>
      <Button  sx={{ marginLeft: "10px",marginRight: "10px",marginBottom: "10px",cursor:"pointer" }} variant="contained" color="success" value={product._id} onClick={handleAddToCart}>
        <AddShoppingCartIcon />
        ADD TO CART
      </Button>
    </Card>
  );
};

export default ProductCard;
